// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__3owkL","header":"MessagesList_header__3pk_v","chat":"MessagesList_chat__3mjCF"};